import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'TEACHER_DETAILS_GET',
  GET_SUCCESS: 'TEACHER_DETAILS_GET_SUCCESS',
  GET_FAILURE: 'TEACHER_DETAIL_GET_FAILURE',
};

export const get = actions.get(
  teacherId => `${BASE_URL}/teachers/${teacherId}/details/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
